import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./registrationDialogStopHold.html')
})
export class RegistrationStopHoldDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<RegistrationStopHoldDialog>) public dialogRef: MatDialogRef<RegistrationStopHoldDialog>) {}

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
